import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import { productParamsById } from 'config/products';
import { ProductCard } from 'components/ProductCard.tsx/ProductCard';
import styles from '../SelectImageStep.scss';
import { useMockupStore } from 'stores/mockupStore';

export const SelectImageStepPreview: FC = () => {
  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const mockups = useMockupStore((state) => state.mockups);
  const isLoading = useMockupStore((state) => state.isLoading);

  return (
    <div className={styles.selectImageStepPreview}>
      <div className={styles.selectImageStepPreviewContent}>
        {selectedProducts.map((productId) => {
          const product = productParamsById[productId];
          const mockupUrl = mockups[productId]?.url;
          return (
            <div key={productId} className={styles.selectImageStepPreviewContentItem}>
              <ProductCard
                imageUrl={mockupUrl ?? product.mockupImageUrl}
                isLoading={isLoading && !mockupUrl}
                buyButtonText="ADD TO CART"
                name={product.name}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
